import { render, staticRenderFns } from "./CardSkeleton.vue?vue&type=template&id=1f0ef654&"
import script from "./CardSkeleton.vue?vue&type=script&lang=js&"
export * from "./CardSkeleton.vue?vue&type=script&lang=js&"
import style0 from "../less/cardSkeleton.less?vue&type=style&index=0&lang=less&module=%24&"

var cssModules = {}
var disposed = false

function injectStyles (context) {
  if (disposed) return
  
        cssModules["$"] = (style0.locals || style0)
        Object.defineProperty(this, "$", {
          configurable: true,
          get: function () {
            return cssModules["$"]
          }
        })
      
}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })



        module.hot && module.hot.accept(["../less/cardSkeleton.less?vue&type=style&index=0&lang=less&module=%24&"], function () {
          var oldLocals = cssModules["$"]
          if (oldLocals) {
            var newLocals = require("../less/cardSkeleton.less?vue&type=style&index=0&lang=less&module=%24&")
            if (JSON.stringify(newLocals) !== JSON.stringify(oldLocals)) {
              cssModules["$"] = newLocals
              require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js").rerender("1f0ef654")
            }
          }
        })

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f0ef654')) {
      api.createRecord('1f0ef654', component.options)
    } else {
      api.reload('1f0ef654', component.options)
    }
    module.hot.accept("./CardSkeleton.vue?vue&type=template&id=1f0ef654&", function () {
      api.rerender('1f0ef654', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/board/components/CardSkeleton.vue"
export default component.exports